import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
  Optional,
  Type,
} from '@angular/core';
import { Document } from '@contentful/rich-text-types';
import { NodeRenderer } from 'ngx-contentful-rich-text';

import { PanelType } from './models/panel.enum';
import { CONTENTFUL_NODE_RENDERERS } from '@nibtravel/shared/util/constants';

@Component({
  selector: 'nibtravel-panel',
  templateUrl: './panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelComponent {
  @Input()
  @HostBinding('id')
  id!: string;
  @Input() style: PanelType = PanelType.Primary;
  @Input() title!: string;
  @Input() subtitle!: string;
  /** Contentful Rich Text fields */
  @Input() richText!: Document;
  @Input() nodeRenderers!: Record<string, Type<NodeRenderer>>;

  @Input() cssClass!: string;

  constructor(
    @Optional()
    @Inject(CONTENTFUL_NODE_RENDERERS)
    nodeRenderers: Record<string, Type<NodeRenderer>>
  ) {
    this.nodeRenderers = nodeRenderers;
  }

  @HostBinding('class')
  get hostCss(): string {
    return `panel panel--${this.style} ${this.cssClass ?? ''}`;
  }
}
